import type { MentionData, MentionOption } from './use-graph-metions';

export type CocoInputPrimitiveType = 'string' | 'number' | 'boolean' | 'super';

export type CocoInputConstructPayload = {
  kind: 'construct';
};

export type CocoInputResolvedPayload = {
  inputKey: string;
  inputType: CocoInputPrimitiveType;
};

/** Payload for Coco rich-editor `t: "input"` mentions (not used by the data graph). */
export type CocoInputMentionData = {
  t: 'input';
  name: string;
  data: CocoInputConstructPayload | CocoInputResolvedPayload;
};

export type CocoMentionData = MentionData | CocoInputMentionData;

export type CocoMentionOption = Omit<MentionOption, 'data'> & {
  data: CocoMentionData;
};

export const isCocoInputConstructMention = (
  data: { readonly t?: string; readonly data?: unknown } | undefined
): boolean => {
  if (data?.t !== 'input') {
    return false;
  }
  const inner = data.data;
  if (typeof inner !== 'object' || inner === null || !('kind' in inner)) {
    return false;
  }
  return (inner as { kind: string }).kind === 'construct';
};
